(function () {
  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.from((root || document).querySelectorAll(sel)); }

  function money(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function discountBadge(compare, price) {
    if (!compare || !price || compare <= price) return '';
    var pct = Math.round((1 - (price / compare)) * 100);
    if (pct <= 0) return '';
    return (pct + '% korting'); // lowercase
  }

  function getVariantIdFromForm(form, fallbackId) {
    if (!form) return fallbackId || null;

    // themes can have multiple id inputs; pick the first inside the add-to-cart form
    var idEl =
      form.querySelector('input[name="id"]') ||
      form.querySelector('select[name="id"]');

    if (!idEl) return fallbackId || null;
    var n = parseInt(idEl.value, 10);
    return Number.isFinite(n) ? n : (fallbackId || null);
  }

  function rebuildSelect(selectEl, allocations, preserveValue) {
    if (!selectEl) return;

    var prev = preserveValue ? selectEl.value : '';
    selectEl.innerHTML = '';

    (allocations || []).forEach(function (a) {
      var opt = document.createElement('option');
      opt.value = String(a.id);
      opt.textContent = a.name;
      opt.dataset.price = String(a.price);
      opt.dataset.compare = String(a.compare);
      selectEl.appendChild(opt);
    });

    if (!allocations || !allocations.length) return;

    if (prev && Array.from(selectEl.options).some(function (o) { return o.value === prev; })) {
      selectEl.value = prev;
    } else {
      selectEl.value = String(allocations[0].id);
    }
  }

  function applyPrices(root, variantPrice, selectEl) {
    var subPriceEl = $('[data-ok-sub-price]', root);
    var compareEl  = $('[data-ok-compare]', root);
    var badgeEl    = $('[data-ok-badge]', root);

    var opt = selectEl && selectEl.selectedOptions ? selectEl.selectedOptions[0] : null;
    if (!opt) return;

    var p = parseInt(opt.dataset.price || '0', 10);
    var c = parseInt(opt.dataset.compare || String(variantPrice), 10);

    if (subPriceEl) subPriceEl.textContent = money(p);
    if (compareEl)  compareEl.textContent  = money(c);

    var isActie = c > p;
    if (subPriceEl) subPriceEl.classList.toggle('ok-sp__price--actie', isActie);
    if (badgeEl)    badgeEl.classList.toggle('ok-sp__badge--actie', isActie);

    var b = discountBadge(c, p);
    if (badgeEl) {
      badgeEl.style.display = b ? '' : 'none';
      badgeEl.textContent = b || '';
    }
  }

  function toggleKaching(root, show) {
    $all('kaching-bundle', root).forEach(function (el) {
      el.classList.toggle('ok-hidden', !show);
    });
  }

  // ✅ Find the real add-to-cart form in the same product section
  function findAddToCartForm(sectionRoot) {
    // Most themes: product-form wrapper or direct form[action="/cart/add"]
    var form =
      sectionRoot.querySelector('product-form form[action*="/cart/add"]') ||
      sectionRoot.querySelector('form[action*="/cart/add"]');

    return form || null;
  }

  // ✅ Ensure there is a selling_plan input INSIDE the real form
  function ensureSellingPlanInputInForm(form, uid) {
    if (!form) return null;

    // Prefer an injected one (unique per widget)
    var injected = form.querySelector('input[name="selling_plan"][data-ok-selling-plan-injected="' + uid + '"]');
    if (injected) return injected;

    // If theme already has one, we can reuse it (but we mark ours so we don't fight others)
    var existing = form.querySelector('input[name="selling_plan"]');
    if (existing && !existing.hasAttribute('data-ok-selling-plan-injected')) {
      // If there is already a selling_plan input, reuse it (do not create duplicates)
      return existing;
    }

    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'selling_plan';
    input.value = '';
    input.setAttribute('data-ok-selling-plan-injected', '');
    input.setAttribute('data-ok-selling-plan-injected', '1');
    input.setAttribute('data-ok-selling-plan-injected', ''); // harmless
    input.setAttribute('data-ok-selling-plan-injected', '1');
    input.setAttribute('data-ok-selling-plan-injected', '');
    // stable unique marker
    input.setAttribute('data-ok-selling-plan-injected', '1');
    input.setAttribute('data-ok-selling-plan-injected', '');
    input.setAttribute('data-ok-selling-plan-injected', '1');
    input.setAttribute('data-ok-selling-plan-injected', '');
    input.setAttribute('data-ok-selling-plan-injected', '1');

    // Use a clean attribute for lookup
    input.removeAttribute('data-ok-selling-plan-injected');
    input.setAttribute('data-ok-selling-plan-injected', uid);

    // Append near the variant id input if possible
    var idEl = form.querySelector('input[name="id"], select[name="id"]');
    if (idEl && idEl.parentNode) {
      idEl.parentNode.insertBefore(input, idEl.nextSibling);
    } else {
      form.appendChild(input);
    }
    return input;
  }

  function initOne(root) {
    var sectionId = root.getAttribute('data-section-id') || '';
    // Unique per widget instance (important if multiple products/sections)
    var uid = root.getAttribute('data-ok-uid');
    if (!uid) {
      uid = (sectionId ? 'sec_' + sectionId : 'sec_x') + '_' + Math.random().toString(16).slice(2);
      root.setAttribute('data-ok-uid', uid);
    }

    var sectionRoot = root.closest('[id^="shopify-section-"]') || document;

    var form = findAddToCartForm(sectionRoot);
    if (!form) return; // cannot wire up

    var spWrap = $('[data-ok-sp]', root);
    var variantMapEl = spWrap ? $('[data-ok-variant-map]', spWrap) : null;
    var map = variantMapEl ? JSON.parse(variantMapEl.textContent || '{}') : null;

    var rOnce = $('#ok-mode-once-' + sectionId, root) || document.getElementById('ok-mode-once-' + sectionId);
    var rSub  = $('#ok-mode-sub-'  + sectionId, root) || document.getElementById('ok-mode-sub-'  + sectionId);

    var selectEl = spWrap ? $('[data-ok-select]', spWrap) : null;

    // Your hidden input inside the widget (nice to keep, but not relied upon)
    var localSellingPlanInput = spWrap ? $('[data-selling-plan-input]', spWrap) : null;

    // ✅ The important one: guaranteed inside add-to-cart form
    var sellingPlanInput = ensureSellingPlanInputInForm(form, uid);

    function writeSellingPlan(val) {
      var v = val || '';
      if (sellingPlanInput) sellingPlanInput.value = v;
      if (localSellingPlanInput) localSellingPlanInput.value = v; // keep in sync for debugging
    }

    function syncVariant(opts) {
      opts = opts || {};
      if (!map || !spWrap || !selectEl) return;

      var vid = getVariantIdFromForm(form, map.current_variant_id);
      var v = map.variants && map.variants[String(vid)];
      if (!v) return;

      rebuildSelect(selectEl, v.allocations || [], !!opts.preserveSelection);
      applyPrices(spWrap, v.price, selectEl);

      // Shopify-native: set selling_plan on form
      writeSellingPlan(selectEl.value || '');
    }

    function setMode(mode) {
      root.setAttribute('data-mode', mode);

      if (mode === 'once') {
        toggleKaching(sectionRoot, true);
        if (spWrap) spWrap.classList.add('ok-hidden');
        writeSellingPlan('');
        root.style.marginBottom = '0px';
      } else {
        toggleKaching(sectionRoot, false);
        if (spWrap) spWrap.classList.remove('ok-hidden');
        syncVariant({ preserveSelection: false });
        root.style.marginBottom = '';
      }
    }

    // init default once
    setMode('once');

    if (rOnce) rOnce.addEventListener('change', function () { setMode('once'); });
    if (rSub)  rSub.addEventListener('change', function () { setMode('sub'); });

    if (selectEl) {
      selectEl.addEventListener('change', function () {
        if (!map) return;
        var vid = getVariantIdFromForm(form, map.current_variant_id);
        var v = map.variants && map.variants[String(vid)];
        if (v) applyPrices(spWrap, v.price, selectEl);
        writeSellingPlan(selectEl.value || '');
      });
    }

    // Variant change watch (form-scoped)
    form.addEventListener('change', function (e) {
      if (root.getAttribute('data-mode') !== 'sub') return;
      if (!e.target) return;

      if (e.target.name === 'id' || (e.target.matches && e.target.matches('input[name="id"], select[name="id"]'))) {
        syncVariant({ preserveSelection: true });
        return;
      }

      // option selects/radios -> delay for themes that update variant id async
      if (e.target.matches && (e.target.matches('select[name^="options"], input[name^="options"]'))) {
        setTimeout(function () { syncVariant({ preserveSelection: true }); }, 80);
      }
    });

    // Extra safety: some themes mutate the hidden id without firing change
    var idEl = form.querySelector('input[name="id"], select[name="id"]');
    if (idEl && window.MutationObserver) {
      var last = String(idEl.value || '');
      var mo = new MutationObserver(function () {
        var now = String(idEl.value || '');
        if (now !== last) {
          last = now;
          if (root.getAttribute('data-mode') === 'sub') {
            syncVariant({ preserveSelection: true });
          }
        }
      });
      mo.observe(idEl, { attributes: true, attributeFilter: ['value'] });
    }

    // Ensure prices are correct when user immediately switches to sub
    if (selectEl && map) {
      var currentVid = getVariantIdFromForm(form, map.current_variant_id);
      var vv = map.variants && map.variants[String(currentVid)];
      if (vv) applyPrices(spWrap, vv.price, selectEl);
    }
  }

  function boot() {
    // ✅ Only widgets you explicitly place via Custom Liquid (your snippet should have data-ok-selling-plans on the root)
    $all('[data-ok-selling-plans]').forEach(initOne);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
